// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ziCG","content":"styles_content__2K2eB"};